/**
 * The runs reports return at most a fixed number of runs, newest first. When a window holds more,
 * its oldest runs are missing from the page, not absent from the fleet, and the page says so.
 */
export function RunsTruncatedNotice({
  data,
}: {
  data: { runs: readonly unknown[]; truncated?: boolean } | null;
}) {
  if (!data?.truncated) return null;
  return (
    <output className="mb-3 block text-sm text-warning">
      Showing the newest {data.runs.length.toLocaleString()} runs. Older runs in this window are not
      shown.
    </output>
  );
}
